import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Pagination from 'components/shared/pagination';
import { routes } from 'constants/config';
import useFetch from 'hooks/useFetch';
import { Card } from 'ui';
import Skeleton from 'ui/Skeleton';
import PartnerFeedbackSummaryLoading from './PartnerFeedbackSummaryLoading';
import RolePlayFeedbackTable from './RolePlayFeedbackTable';

const PartnerFeedbackSummary = () => {
  const { rolePlayId } = useParams();
  const { id } = useParams();
  const regex = /\d+/;
  const lessonId = id.match(regex)[0];
  const params = new URLSearchParams(window.location.search);
  const groupId = params.get('group_id');
  const perPage = 5;

  const [page, setPage] = useState(1);

  const { data, loading } = useFetch(
    routes.LESSON_OVERVIEW.ROLE_PLAY_FEEDBACKS_DATA(
      lessonId,
      rolePlayId,
      groupId,
      page,
      perPage,
    ),
  );

  const LearnerTables = () => {
    return data?.learners.data.map(learner => {
      const FeedbackTables = () => {
        return learner.submittedFeedback.map(feedback => {
          return (
            <RolePlayFeedbackTable
              partnerName={feedback.partner}
              comments={feedback.feedback}
              criteria={feedback.criteria}
              overallScore={feedback.overallScore}
              key={feedback.id}
            />
          );
        });
      };
      return (
        <div key={learner.id}>
          <Text
            className="mb-24 mt-30 d-b"
            variant={TEXT_VARIANTS.SUBHEADER_BOLD}
            key={learner.id}
          >
            {learner.learnerName}
          </Text>
          <FeedbackTables />
        </div>
      );
    });
  };

  return (
    <Card className="mb-32">
      <Card.Content padding="large">
        <div className="d-f fd-c mb-40">
          {!loading && (
            <Text className="mt-32 mb-32" variant={TEXT_VARIANTS.BODY}>
              {t('practice.role_play.feedback.lesson_name')}
              <a className="c-link pl-4" href={routes.LESSON(id)}>
                {data?.lessonTitle ||
                  t('practice.role_play.titles.untitled_lesson')}
              </a>
            </Text>
          )}
          {loading && (
            <div className="mt-32 mb-32">
              <Skeleton count={1} />
            </div>
          )}
          <Text className="pb-20" variant={TEXT_VARIANTS.TITLE_BOLD}>
            {!loading &&
              (data?.rolePlayTitle ||
                t('practice.role_play.feedback.untitled'))}
            {loading && <Skeleton count={1} />}
          </Text>
          <hr className="border-gray-light w-100p" />

          {!loading &&
            (data?.learners?.totalLearners > 0 ? (
              <>
                <LearnerTables />
                <Pagination
                  pages={data?.learners.totalPages}
                  selected={page}
                  pageSelectCallback={setPage}
                  customClass="mt-24 ta-l"
                />
              </>
            ) : (
              <div>
                <Text
                  className="pb-12 d-f jc-c"
                  variant={TEXT_VARIANTS.TITLE_BOLD}
                >
                  {t('practice.role_play.feedback.no_responses.title')}
                </Text>
                <Text className="d-f jc-c" variant={TEXT_VARIANTS.BODY}>
                  {t('practice.role_play.feedback.no_responses.info')}
                </Text>
              </div>
            ))}
          {loading && <PartnerFeedbackSummaryLoading />}
        </div>
      </Card.Content>
    </Card>
  );
};

export default PartnerFeedbackSummary;
